export const valueToString = (value) => {
  if (value !== undefined) {
    return String(value);
  }
}
